import React from 'react';
import PropTypes from 'prop-types';

import Image from '../Image';
import { IconCheck, IconExclamationMark } from '../Icons';

import { StyledGridItem, StyledTooltip, StyledImageButton, StyledSelectedIconWrapper, StyledSoldOutOverlay } from './VisualizerProductListItemStyles';

var _ref = React.createElement(
  StyledSoldOutOverlay,
  null,
  'SOLD OUT'
);

var _ref2 = React.createElement(IconExclamationMark, null);

var _ref3 = React.createElement(IconCheck, { stroke: '#FFFFFF' });

var VisualizerProductListItem = function VisualizerProductListItem(props) {
  var handleClick = function handleClick() {
    props.handleProductSelection(props.product);
  };

  var productSelected = props.selectedProducts.some(function (sp) {
    return sp.variantId === props.product.variantId;
  });
  var productSoldOut = !props.isStaging && !props.product.availableForSale;

  return React.createElement(
    StyledGridItem,
    null,
    React.createElement(
      StyledTooltip,
      null,
      props.product.shortname ? props.product.shortname : props.product.parentTitle
    ),
    React.createElement(
      StyledImageButton,
      {
        onClick: handleClick,
        selected: productSelected,
        productSoldOut: productSoldOut,
        disabled: productSoldOut && !productSelected
      },
      React.createElement(Image, {
        alt: props.product.parentTitle,
        src: props.product.image.thumbnailImg
      }),
      productSoldOut && _ref,
      React.createElement(
        StyledSelectedIconWrapper,
        {
          selected: productSelected,
          productSoldOut: productSoldOut
        },
        productSoldOut ? _ref2 : _ref3
      )
    )
  );
};

VisualizerProductListItem.propTypes = {
  product: PropTypes.object.isRequired,
  selectedProducts: PropTypes.array,
  categoryTitle: PropTypes.string,
  maxItems: PropTypes.number.isRequired,
  handleProductSelection: PropTypes.func,
  isStaging: PropTypes.bool.isRequired
};

export default VisualizerProductListItem;